<template>
   <v-container>
      <v-card>
        <v-card-title class="d-flex justify-space-between">
              <span class="white--text">{{ $t('ARRANGE_DESIRES') }}</span>
        </v-card-title>
        <v-card-text>
        <v-data-table
          :items="serverTranslateArrayKeys(orderedApplications, ['facultyName','status'])"
          :headers="headers"
          class="elevation-1 pointer mt-5"
                :items-per-page="-1"
          :hide-default-footer="true"
           v-if="orderedApplications.length"
        >

          <template v-slot:item.status="{ item }">
              <span class="font-weight-medium">
                {{ statuses[item.status] }}
              </span>
            </template>
          <template v-slot:item.actions="{ index }">
            <v-btn icon @click="moveUp(index)" :disabled="index === 0">
              <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
            <v-btn icon @click="moveDown(index)" :disabled="index === orderedApplications.length - 1">
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
        </v-data-table>

     <div v-else class="text-center mt-4 red--text">
          {{ $t('DESIRE_MESSAGE')}}
         </div>
          <div class="d-flex justify-center mt-4"  v-if="orderedApplications.length">
            <v-btn
              color="primary"
              class="mt-4"
              @click="saveOrder"
            >
              <v-icon left>mdi-content-save</v-icon>
              {{ $t('SAVE_ORDER') }}
            </v-btn>
              <v-btn
              color="primary"
              class="mt-4 mr-4"
              @click="printDesiresStudent"
            >
              <v-icon left>mdi-printer</v-icon>
              {{ $t('PRINT_DESIRE_FORM') }}
            </v-btn>
           <div ref="printSection" style="display: none">
              <PrintDataTable :orderedApplications="originalOrder"   :studentName="student.name"
  :cardId="student.cardId" :logoSrc="logoSrc"/>
            </div>
          </div>

         <ad-confirmDialog ref="confirm"></ad-confirmDialog>
        </v-card-text>

      </v-card>
   </v-container>
</template>

<script>
import serverTranslationsMixin from "@/mixins/serverTranslations.js";
import ConfirmDialog from "@/components/shared/ConfirmDialog";
import PrintDataTable from '@/components/modules/studentApplications/PrintDesireTable.vue';
export default {

  components: {
     "ad-confirmDialog": ConfirmDialog,
    PrintDataTable
  },
    mixins: [serverTranslationsMixin],
   data() {
    return {
      orderedApplications: [],
      originalOrder: [],
      student:{},
      logoSrc: localStorage.getItem('logo') || null


    };
  },
   mounted(){
     this.initializeList()
   },
  computed: {
      direction: function() {
       return this.$store.state.direction
    },
     hasUnsavedChanges() {
    return JSON.stringify(this.orderedApplications) !== JSON.stringify(this.originalOrder);
  },
     headers:function() {
       return [
        {
          text: this.$t("FACULTY"),
          align: "start",
          sortable: false,
          value: "facultyName"
        },
            {
          text: this.$t("ADMISSION_DATA.APPID"),
          align: "center",
          sortable: false,
          value: "appNum"
        },
           {
            text:this.$t("ADMISSION_DATA.APP_STATUS"),
            align: "center",
                 sortable: false,
            value: "status"
         },
        {
          text: this.$t("ACTIONS"),
          value: "actions",
          sortable: false
        }
        ]
     },
    statuses: function(){
         return {
         "0":this.$t("DRAFT_APPLY"),
         "-2":this.$t("INITIAL_DRAFT_APPLY"),
         "1":this.$t("UNDER_REVIEW"),
         "-1":this.$t("INITIAL_UNDER_REVIEW"),
         "2":this.$t("ACCEPTED"),
         "3":this.$t("REJECTED"),
         "4":this.$t("TO_BE_COMP"),
         "5":this.$t("ACCEPT_CANDIDATE"),
         "6":this.$t("REJECT_CANDIDATE"),
         "7": this.$t("SEND_NO_FEES"),
         "8": this.$t("TRANSFERRED"),
         "9": this.$t("REFUSED_AS_OTHER_ACCEPTED"),
         "10": this.$t("WAITING")
      }
   }
     },
  methods: {
       initializeList() {

         this.$http.post("/api/applications/list_applications_ordered/")
         .then(
            res => {
               let applicationsArr = []
               if (res.data && res.data.data && res.data.data.length > 0) {
             this.student={
                   "name":res.data.data[0].studentName,
                       "cardId":res.data.data[0].cardId
                 }
                  for (var i = 0; i < res.data.data.length; i++) {

                     let app = {}
                     app = {
                        "n":(i+1),
                       "facultyName":res.data.data[i].appFaculty?.appFacName || "",
                          "status":res.data.data[i].appStatus ,
                        "editable":res.data.data[i].editable,
                        "deleteable":res.data.data[i].deleteable,
                        "appNum":res.data.data[i].appID,
                          "desireNumber":res.data.data[i].desireNumber,
                       "certificateType":res.data.data[i].certificateType,
                        "certificateSpecialization":res.data.data[i].certificateSpecialization,
                     }
                     applicationsArr.push(app)
                  }
                 this.originalOrder = JSON.parse(JSON.stringify(applicationsArr)); // deep copy
                this.orderedApplications = applicationsArr

               }
            },
            err => {
               this.$toasted.show(
                this.serverTranslate(err.response.data.message),
                {
                   type: "error",
                   icon: "error_outline",
                   theme: "bubble",
                   position: "bottom-left",
                   duration: 3000
                }
               );
            }
         )
    },
    moveUp(index) {
      const temp = this.orderedApplications[index - 1];
      this.$set(this.orderedApplications, index - 1, this.orderedApplications[index]);
      this.$set(this.orderedApplications, index, temp);
    },
    moveDown(index) {
      const temp = this.orderedApplications[index + 1];
      this.$set(this.orderedApplications, index + 1, this.orderedApplications[index]);
      this.$set(this.orderedApplications, index, temp);
    },
    printDesiresStudent(){
      if (this.hasUnsavedChanges) {
          this.$refs.confirm
            .open(this.$t("WARNING"), this.$t("YOU_HAVE_UNSAVED_DESIRES"))
            .then(confirm => {
              if (confirm) {
                this.triggerPrint();
                  }
                });
            } else {
              this.triggerPrint();
            }


    },
    triggerPrint() {
      const printContents = this.$refs.printSection.innerHTML;
      const html = `
        <html>
          <head>
            <title>${this.$t('PRINT_DESIRE_FORM')}</title>
                  <link href="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css" rel="stylesheet">

            <style>
              table {
                width: 100%;
                border-collapse: collapse;
              }
              th, td {
                border: 1px solid #000;
                padding: 8px;
                text-align: center;
              }
            </style>
          </head>
          <body>${printContents}</body>
        </html>
      `;
      const printWindow = window.open('', '_blank');
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.print();
    },

     saveOrder() {
       this.$refs.confirm
           .open("CONFIRMATION_MESSAGE", "DESIRE_CONFIRMATION")
           .then(confirm => {
             if (confirm) {
               this.$http.put("/api/applications/update_student_order_applications/", this.orderedApplications)
                   .then(
                       res => {
                         this.dialog = false;
                         this.originalOrder = JSON.parse(JSON.stringify(this.orderedApplications));
                         this.$toasted.show(this.serverTranslate(res.data.message), {
                           type: "success",
                           icon: "check_circle_outline",
                           duration: 3000,
                           theme: "bubble",
                           position: "bottom-left"
                         });
                       },
                       err => {
                         this.$toasted.show(
                             this.serverTranslate(err.response.data.message),
                             {
                               type: "error",
                               icon: "error_outline",
                               theme: "bubble",
                               position: "bottom-left",
                               duration: 3000
                             }
                         );
                       }
                   )


             }

           });
     },

  }

};
</script>